import { WORDPRESS_API } from "shared/constants/api";


export const internshipSpecialistProject = {
  id: "internship-specialist",

  title: "Od stażysty do specjalisty",

  description:
    "Archiwalny projekt wspierający rozwój zawodowy uczniów.",

  image: {
    src: `${WORDPRESS_API}/wp-content/uploads/2019/04/Plakat-1.jpg`,
    alt: "Od stażysty do specjalisty",
    maxWidth: "900px"
  },

  projectInfoUrl:
    `${WORDPRESS_API}/wp-content/uploads/2019/04/o-projekcie.pdf`,

  externalUrl:
    "https://www.powiat.pila.pl/fundusze-pomocowe/realizowane-projekty/160,od-stazysty-do-specjalisty",

  externalImage: {
    src: `${WORDPRESS_API}/wp-content/uploads/2019/04/SZECZOLOWE.jpg`,
    alt: "Szczegółowe informacje o projekcie"
  }
};


export const participantDocuments = [
  {
    id: "support-card",
    title: "Karta udzielonego wsparcia uczestnika projektu",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Karta-udzielonego-wsparcia-uczestnika-projektu.pdf`
  },
  {
    id: "education-place",
    title: "Oświadczenie o miejscu pobierania nauki",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Oświadczenie-o-miejscu-pobierania-nauki.pdf`
  },
  {
    id: "participant-statement",
    title: "Oświadczenie uczestnika projektu",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Oświdczenie-uczestnika-projektu.pdf`
  },
  {
    id: "recruitment-form",
    title: "Wzór formularza rekrutacyjnego",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Wzór_formularza_rekrutacyjnego_Wyrzysk.pdf`
  },
  {
    id: "recruitment-form-example",
    title: "Wzór wypełnienia formularza rekrutacyjnego",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Wzór_wypełnienia_formularza_rekrutacyjnego_Wyrzysk.pdf`
  }
];


export const staffDocuments = [
  {
    id: "staff-form",
    title: "Formularz personelu projektu",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/FORMULARZ-PERSONEL-PROJEKTU-1.pdf`
  },
  {
    id: "employee-delegation",
    title: "Oddelegowanie pracownika",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Oddelegowanie_pracownika_Wyrzysk.pdf`
  },
  {
    id: "project-involvement",
    title: "Oświadczenie dotyczące zaangażowania w projekcie",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/OSwiadczenie_dotyczące_zaangażowania_w_projekcie_wyrzysk.pdf`
  },
  {
    id: "staff-statement",
    title: "Oświadczenie personelu projektu",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Oświadczenie-personelu-projektu.pdf`
  },
  {
    id: "work-time-protocol",
    title:
      "Protokół realizacji zadań projektu wraz z kartą czasu pracy",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/PROTOKÓŁ-REALIZACJI-ZADAŃ-PROJEKTU-WRAZ-Z-KARTĄ-CZASU-PRACY.pdf`
  },
  {
    id: "duties",
    title: "Szczegółowy zakres obowiązków",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Szczegolowy_zakres_obowiazkow_Wyrzysk.pdf`
  }
];